module.exports = __webpack_public_path__ + "img/link.776b567c.svg";